import { render, staticRenderFns } from "./support-case-slider.vue?vue&type=template&id=5e296544&"
import script from "./support-case-slider.vue?vue&type=script&lang=tsx&"
export * from "./support-case-slider.vue?vue&type=script&lang=tsx&"
import style0 from "./support-case-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports